import {Box} from "@mui/material";
import {SxProps} from "@mui/system";
import {Container} from "./Container";
import {Colors} from "../colors";

type CircleDotProps = {
  color?: string;
  size?: number;
  sx?: SxProps;
};

export const CircleDot = ({color, size = 10, sx}: CircleDotProps) => {
  return (
    <Container>
      <Box
        sx={{
          width: size,
          height: size,
          backgroundColor: color || Colors.bw.black,
          borderRadius: "50%",
          ...sx,
        }}
      />
    </Container>
  );
};
